<template>
  <div class="tw-inline-block">
    <IconButton
      color="outline-secondary"
      @click="openModal(MODAL_NAME)"
      test_id="social-profile-edit"
    >
      <PenIcon />
    </IconButton>

    <FormModal header="Edit Social Links" name="edit-social-media">
      <FormModalBody
        footer-button-text="Save"
        :is-button-loading="form.processing"
        @submit="submitForm"
      >
        <div>
          <FormInput
            v-for="(socialProfile, index) in socialProfiles"
            :key="index"
            v-model="form[socialProfile]"
            class="tw-mb-4"
            type="text"
            :placeholder="placeholders[socialProfile]"
            :is-error="Boolean(form.errors[socialProfile])"
            :errors="form.errors[socialProfile]"
            @input="form.clearErrors(socialProfile)"
            :test_id="`social-profile-input-${socialProfile}`"
          >
            <template #label>
              {{ _capitalize(socialProfile) }}
            </template>
          </FormInput>
        </div>
      </FormModalBody>
    </FormModal>
  </div>
</template>

<script setup>
import _capitalize from 'lodash/capitalize'
import IconButton from './IconButton.vue'
import FormModal from './modals/FormModal/FormModal.vue'
import FormModalBody from './modals/FormModal/FormModalBody.vue'
import FormInput from './forms/FormInput.vue'
import PenIcon from '@/assets/images/icons/pen.svg'
import { useForm } from '@inertiajs/vue3'
import { useModals } from '@/shared/composables/useModals.js'

const props = defineProps({
  socialMedia: {
    type: Object,
    required: true,
  },
  url: {
    type: String,
    required: true,
  },
})

const { openModal, closeModal } = useModals()

const MODAL_NAME = 'edit-social-media'
const form = useForm({
  ...props.socialMedia,
})
const placeholders = {
  medium: 'https://medium.com/@username',
  twitter: 'https://twitter.com/username',
  linkedin: 'https://linkedin.com/username',
  instagram: 'https://instagram.com/username',
}
const socialProfiles = ['medium', 'twitter', 'linkedin', 'instagram']

const submitForm = () => {
  form
    .transform((data) => ({
      [props.url.includes('mentor') ? 'mentor' : 'mentee']: {
        social_profile: data,
      },
    }))
    .patch(props.url, {
      preserveScroll: true,
      onSuccess: () => {
        closeModal(MODAL_NAME)
      },
    })
}
</script>
